import { data, user } from '../data/db-data'

export const contactsInitialState = {}

export const messagesInitialState = {}

export const userInitialState = {
  data,
  user,
  myID: 0
}
